import CustomImgTag from "../shared/CustomImgTag";

const LeapAdvantageCard = ({
  imgAlt,
  webImg,
  mobileImg,
  title,
  subTitle,
  webImgHeight,
  webImgWidth,
  mobileImgWidth,
  mobileImgHeight,
}) => {
  return (
    <div className="shadow-3 rounded-default bg-white flex md:block justify-between items-center pr-1 md:pr-0 pt-3 pb-4 md:pb-12">
      <div>
        <CustomImgTag
          className="mx-auto"
          altText={imgAlt}
          srcWeb={webImg}
          srcMobile={mobileImg}
          webImgWidth={webImgWidth}
          webImgHeight={webImgHeight}
          mobileImgWidth={mobileImgWidth}
          mobileImgHeight={mobileImgHeight}
        />
      </div>
      <div className="text-center">
        <p className="text-base md:text-lg text-blue-950 pb-2 md:pb-6 font-bold">
          {title}
        </p>
        <p className="text-sm md:text-base text-gray2-600">{subTitle}</p>
      </div>
    </div>
  );
};

export default LeapAdvantageCard;
